import {
  FirstSection,
  ProductSection,
  ProductItem,
  SupportedChains,
  HowToUse,
  StepWrapper,
  StepItem,
  TextStepWrapper,
  ImageAbsolute,
  InvestorAndPartner,
  Blog,
  SectionTitle,
  Line
} from './Styled'
import BridgeIcon from 'assets/images/material-symbols_token.svg'
import Image1 from 'assets/images/image-1.svg'
import ArcadiaLogo from 'assets/images/arcadia.svg'
import MultiChain from 'assets/images/multi-chain.svg'
import CrossChain from 'assets/images/cross-chain.svg'
import Privacy from 'assets/images/security.svg'
import EthereumChain from 'assets/images/ethereum.svg'
import BnbChain from 'assets/images/bnb-chain.svg'
import Moonbeam from 'assets/images/Moonbeam.svg'
import Avalanche from 'assets/images/avalanche.svg'
import Casper from 'assets/images/casper.svg'
import OkxChain from 'assets/images/okx.svg'
import Image2 from 'assets/images/image-2.svg'
import Image3 from 'assets/images/image-3.svg'
import Bridge1 from 'assets/images/bridge-1.svg'
import Bridge2 from 'assets/images/bridge-2.svg'
import Bridge3 from 'assets/images/bridge-3.svg'
import BlogArcadia from 'assets/images/DOTxArcadia.png'
import BlogFiro from 'assets/images/DOTxFiro.png'
import BlogAurora from 'assets/images/DOTxAurora.png'
import BlogOkc from 'assets/images/DOTxOkc.png'
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react'
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import Investor from './Investor'

function HomePage(): JSX.Element {

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <FirstSection>
        <div>
          <p
            style={{
              color: '#fff',
              fontSize: '3rem',
              fontWeight: '600',
              fontFamily: 'Montserrat',
              textAlign: 'left',
              lineHeight: '5rem',
            }}
          >
            The Future of Cross Chain
          </p>
          <p style={{ color: '#fff', fontSize: '1rem', fontWeight: '400', fontFamily: 'Montserrat', margin: '2.5rem 0rem' }}>
            The ultimate future of Web3 and Defi
          </p>
          <button
            className='d-flex align-items-center gap-1'
            style={{ backgroundColor: '#fff', borderRadius: '2rem', padding: '0.5rem 2rem', color: '#fff', border: 'none' }}
            onClick={() => window.open("https://app.paradiso.io/", "_blank")}
          >
            <img src={BridgeIcon} width={20} height={20} />
            <p style={{ color: '#13599d', fontSize: '0.875rem', fontWeight: '400', fontFamily: 'Montserrat' }}>
              Bridge Now
            </p>
          </button>
          <div className='d-flex align-items-center gap-3 mt-5'>
            <p style={{ color: '#fff', fontFamily: 'Montserrat', fontSize: '0.875rem' }}>
              Audit by
            </p>
            <img src={ArcadiaLogo} width={100} />
          </div>
          <div className='d-flex align-items-center gap-3 mt-5'>
            <div className='d-flex flex-column align-items-center'>
              <p style={{ color: '#fff', fontFamily: 'Montserrat', fontSize: '1.25rem' }}>
                1-5 mins
              </p>
              <p style={{ color: '#00fffd', fontFamily: 'Montserrat', fontSize: '0.875rem' }}>
                Transfer time
              </p>
            </div>
            <div className='d-flex flex-column align-items-center' style={{ borderLeft: '1px solid #fff', borderRight: '1px solid #fff', padding: '0rem 1rem' }}>
              <p style={{ color: '#fff', fontFamily: 'Montserrat', fontSize: '1.25rem' }}>
                9+
              </p>
              <p style={{ color: '#00fffd', fontFamily: 'Montserrat', fontSize: '0.875rem' }}>
                Supported chains
              </p>
            </div>
            <div className='d-flex flex-column align-items-center'>
              <p style={{ color: '#fff', fontFamily: 'Montserrat', fontSize: '1.25rem' }}>
                20+
              </p>
              <p style={{ color: '#00fffd', fontFamily: 'Montserrat', fontSize: '0.875rem' }}>
                Tokens
              </p>
            </div>
          </div>
        </div>
        <div
          className='d-md-none d-lg-block'
          style={{ position: 'absolute', top: '10%', left: '60%' }}
        >
          <ImageAbsolute src={Image1} width={520} />
        </div>
      </FirstSection>
      <ProductSection id='products'>
        <SectionTitle>
          Our Products
        </SectionTitle>
        <div className='row justify-content-center'>
          <ProductItem className='col-lg-6 col-md-8 col-sm-12'>
            <img src={CrossChain} />
            <p style={{ fontFamily: 'Montserrat', color: '#13599d', fontSize: '1rem', fontWeight: '600' }}>
              Cross Chain Interoperability
            </p>
            <p style={{ fontFamily: 'Montserrat', color: '#777e90', fontSize: '0.875rem', margin: '1.5rem 0rem', lineHeight: '1.15rem' }}>
              Communicate across protocols and blockchains with ease, supporting a number of formats and unique functionalities to make your life easier.
            </p>
            <button >
              Learn more
            </button>
          </ProductItem>
          <ProductItem className='col-lg-6 col-md-8 col-sm-12'>
            <img src={Privacy} />
            <p style={{ fontFamily: 'Montserrat', color: '#13599d', fontSize: '1rem', fontWeight: '600' }}>
              Cross Chain Liquidity
            </p>
            <p style={{ fontFamily: 'Montserrat', color: '#777e90', fontSize: '0.875rem', margin: '1.5rem 0rem', lineHeight: '1.15rem' }}>
              Fast, Affordable and Secure way of moving liquidity between EVM, non EVM (Casper, Near, Solana) and L2 blockchains.
            </p>
            <button>
              Learn more
            </button>
          </ProductItem>
        </div>
      </ProductSection>
      <div style={{ backgroundColor: '#f7f8fc', position: 'relative' }}>
        <ImageAbsolute src={Image2} width={200} style={{ position: 'absolute', left: '87%', top: '-40%' }} />
        <SupportedChains>
          <SectionTitle>
            Our Supported Blockchains
          </SectionTitle>
          <div className='d-flex flex-wrap justify-content-center align-items-center gap-3' style={{ marginTop: '5rem' }}>
            <svg viewBox='0 0 159 86' xmlns='http://www.w3.org/2000/svg' fillRule='evenodd' strokeLinejoin='round' width={100}>
              <path stroke='#ff2d2e' fill='#ff2d2e' d="M96.63 40.5a6.636 6.636 0 00-2.51-2.45c-1.06-.59-2.25-.89-3.57-.89H71.68c-2.63 0-4.75 2.13-4.75 4.75v43.31h6.87V67.58c0-1.04.8-1.96 1.85-1.98 1.07-.03 1.94.83 1.94 1.89v.18c0 2.09 1.7 3.79 3.79 3.79h9.17c.24 0 .48-.01.72-.03h2.18a4.11 4.11 0 004.11-4.11V44c0-1.32-.31-2.5-.92-3.54M90.69 63.2c0 .4-.15.73-.44 1.01-.26.24-.61.37-.97.37H75.2c-.3 0-.75-.16-.97-.37-.29-.27-.44-.61-.44-1.01V45.4c0-.3.16-.75.37-.97.27-.29.61-.44 1.01-.44h14.11c.3 0 .75.16.97.37.29.27.44.61.44 1.01V63.2zM146.35 64.25c-.29-.27-.44-.61-.44-1.01V45.41c0-.4.15-.73.44-1.01.22-.21.66-.37.97-.37h10.79v-6.87h-4.6a3.82 3.82 0 00-3.82 3.82v.07c0 1.04-.8 1.96-1.84 1.98-1.07.03-1.95-.83-1.94-1.89v-.18c0-2.09-1.7-3.79-3.79-3.79h-8.25v6.87h3.77c.3 0 .75.16.97.37.29.27.44.61.44 1.01v17.8c0 .3-.16.75-.37.97-.27.29-.61.44-1.01.44h-1.31a3.816 3.816 0 00-3.68 3.81v.07c0 1.04-.8 1.96-1.84 1.98-1.07.03-1.94-.83-1.94-1.89v-.18c0-2.05-1.62-3.71-3.65-3.78h-16.6c-.36 0-.68-.13-.96-.4-.28-.27-.42-.59-.42-.97v-4.12c0-.36.14-.68.42-.96.28-.28.6-.42.96-.42h22.29V44.2c0-1.34-.3-2.54-.89-3.6a6.475 6.475 0 00-2.48-2.5c-1.06-.6-2.27-.9-3.64-.9H107.4c-1.32 0-2.51.3-3.57.9-1.06.6-1.9 1.44-2.51 2.5-.61 1.06-.92 2.26-.92 3.6v23.16a4.11 4.11 0 004.11 4.11h2.19c.23.02.47.03.71.03h44.04v-6.87h-4.12c-.36 0-.71-.12-.96-.37m-39.08-18.84c0-.38.14-.7.42-.97.28-.27.6-.4.96-.4h14.05c.4 0 .73.13.99.4s.39.59.39.97v4.12c0 .38-.13.7-.39.97s-.59.4-.99.4h-14.05c-.36 0-.68-.14-.96-.42-.28-.28-.42-.6-.42-.96v-4.12.01zM75.2 6.87h22.34V0h-.32a3.82 3.82 0 00-3.82 3.82v.07c0 1.04-.8 1.96-1.85 1.98-1.07.03-1.95-.83-1.94-1.89V3.8c0-2.09-1.7-3.79-3.79-3.79H73.95c-1.34 0-2.54.3-3.6.9-1.06.6-1.89 1.44-2.5 2.5-.6 1.06-.91 2.26-.91 3.6v6.6c0 1.32.3 2.51.91 3.57.6 1.06 1.44 1.89 2.5 2.5 1.06.6 2.26.91 3.6.91H89.2c.42 0 .84.16 1.12.47.22.25.34.55.34.9V26c0 .42-.16.84-.47 1.12-.25.22-.55.34-.9.34H76.64a3.82 3.82 0 00-3.82 3.82v.07c0 1.04-.8 1.96-1.85 1.98-1.07.03-1.94-.83-1.94-1.89v-.18c0-2.09-1.7-3.79-3.79-3.79h.09c-.53-.05-.95-.38-1.25-.99V7c0-1.34-.3-2.54-.91-3.6a6.596 6.596 0 00-2.5-2.5c-1.06-.6-2.26-.9-3.6-.9H33.43v6.87h22.32c.42 0 .84.16 1.12.47.22.25.34.55.34.9v4.04c0 .42-.16.84-.47 1.12-.25.22-.55.34-.9.34H40.45c-1.34 0-2.54.3-3.6.9-1.06.6-1.89 1.44-2.5 2.5-.6 1.06-.91 2.25-.91 3.57v6.6c0 1.34.3 2.54.91 3.6.6 1.06 1.44 1.89 2.5 2.5 1.06.6 2.26.91 3.6.91h9.2a3.82 3.82 0 003.82-3.82v-.07c0-1.04.8-1.96 1.85-1.98 1.07-.03 1.95.83 1.94 1.89v.18c0 2.09 1.7 3.79 3.79 3.79h29.49c1.34 0 2.54-.3 3.6-.91 1.06-.6 1.89-1.44 2.5-2.5.6-1.06.9-2.26.9-3.6v-6.6c0-1.32-.3-2.51-.9-3.57a6.596 6.596 0 00-2.5-2.5c-1.06-.6-2.26-.9-3.6-.9H75.28c-.42 0-.84-.16-1.12-.47-.22-.25-.34-.55-.34-.9V8.32c0-.42.16-.84.47-1.12.25-.22.55-.34.9-.34m-17.98 19.2c0 .35-.11.65-.34.9-.28.32-.7.47-1.12.47h-14c-.42 0-.84-.16-1.12-.47-.22-.25-.34-.55-.34-.9v-4.04c0-.42.16-.84.47-1.12.25-.22.55-.34.9-.34h14.08c.42 0 .84.16 1.12.47.22.25.34.55.34.9v4.12l.01.01zM6.87 26.08V8.32c0-.42.16-.84.47-1.12.25-.22.55-.34.9-.34h22.35V0h-.32a3.82 3.82 0 00-3.82 3.82v.07c0 1.04-.8 1.96-1.85 1.98-1.07.03-1.94-.83-1.94-1.89V3.8c0-2.09-1.7-3.79-3.79-3.79H7c-1.34 0-2.54.3-3.6.9-1.06.6-1.89 1.44-2.5 2.5C.3 4.47 0 5.67 0 7.01v20.31c0 1.34.3 2.54.9 3.6.6 1.06 1.44 1.89 2.5 2.5 1.06.6 2.26.91 3.6.91h23.59v-6.87H8.32c-.42 0-.84-.16-1.12-.47-.22-.25-.34-.55-.34-.9">

              </path>
            </svg>
            <img src={EthereumChain} width={140} />
            <img src={BnbChain} width={140} />
            <img src={Moonbeam} width={140} />
            <img src={Avalanche} width={140} />

            <img src={OkxChain} width={140} />
          </div>
        </SupportedChains>
        <ImageAbsolute src={Image3} width={150} style={{ position: 'absolute', left: '0%', top: '58%' }} />
      </div>
      <HowToUse>
        <SectionTitle>
          How to Use Paradiso Bridge?
        </SectionTitle>
        <div className='d-flex flex-sm-row flex-md-column gap-3' style={{ margin: '5rem 0rem' }}>
          <StepWrapper>
            <StepItem>1</StepItem>
            <Line />
            <StepItem>2</StepItem>
            <Line />
            <StepItem>3</StepItem>
            <Line />
            <StepItem>4</StepItem>
          </StepWrapper>
          <TextStepWrapper style={{ gap: '5.5rem' }}>
            <p style={{ fontFamily: 'Montserrat', color: '#13599d', fontSize: '0.875rem', fontWeight: '600' }}>
              Connect wallet A
            </p>
            <p style={{ fontFamily: 'Montserrat', color: '#13599d', fontSize: '0.875rem', fontWeight: '600' }}>
              Send assets
            </p>
            <p style={{ fontFamily: 'Montserrat', color: '#13599d', fontSize: '0.875rem', fontWeight: '600' }}>
              Connect wallet B
            </p>
            <p style={{ fontFamily: 'Montserrat', color: '#13599d', fontSize: '0.875rem', fontWeight: '600' }}>
              Receive assets
            </p>
          </TextStepWrapper>
        </div>
        <div className='d-flex flex-row justify-content-center' style={{ position: 'relative' }}>
          <ImageAbsolute src={Bridge1} width={500} />
          <ImageAbsolute src={Bridge2} width={300} style={{ position: 'absolute' }} />
          <ImageAbsolute src={Bridge3} width={500} />
        </div>
      </HowToUse>

      <InvestorAndPartner id='partners'>
        <SectionTitle style={{ marginBottom: '5rem' }}>
          Investor & Partners
        </SectionTitle>

        <Investor />
      </InvestorAndPartner>
      <Blog id='blog'>
        <div className='d-flex justify-content-between align-items-center'>
          <SectionTitle>
            Blog
          </SectionTitle>
        </div>
        <div className='my-5' style={{ position: 'relative' }}>
          <div className='d-lg-flex d-md-none gap-3' style={{ position: 'absolute', top: '-22%', left: '91%' }}>
            <div className='prev' style={{ width: 'fit-content', padding: '0.5rem', border: '1px solid #13599d', borderRadius: '2rem', cursor: 'pointer' }}>
              <FaAngleLeft size={20} color='#13599d' />
            </div>
            <div className='next' style={{ width: 'fit-content', padding: '0.5rem', backgroundColor: '#13599d', border: '1px solid #13599d', borderRadius: '2rem', cursor: 'pointer' }}>
              <FaAngleRight size={20} color='#fff' />
            </div>
          </div>
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            pagination={true}
            loop={true}
            autoplay={true}
            speed={250}
            spaceBetween={10}
            slidesPerView={1}
            centeredSlides={false}
            navigation={{
              prevEl: '.prev',
              nextEl: '.next',
            }}
            breakpoints={{
              768: {
                width: 768,
                slidesPerView: 2,
              },
              1200: {
                width: 1200,
                slidesPerView: 3,
              },
            }}
          >
            <SwiperSlide>
              <div onClick={() => window.open("https://medium.com/@dotoracle.network/arcadia-dotoracle-partnership-building-the-first-cross-chain-bridge-on-casper-network-2fcf13e95abd", "_blank")} style={{ cursor: 'pointer' }}>
                <img src={BlogArcadia} style={{ width: '100%', height: '13rem' }} />
                <div style={{ backgroundColor: '#08143e', padding: '2rem', marginTop: '-0.2rem', height: '8rem' }}>
                  <p style={{ fontFamily: 'Montserrat', color: '#fff', fontSize: '0.875rem', fontWeight: '500', textAlign: 'left', lineHeight: '1.5rem' }}>
                    DotOracle & Arcadia Partnership:Building the First Cross-chain Bridge on Casper network
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div onClick={() => window.open("https://medium.com/@dotoracle.network/firo-dotoracle-partnership-integration-dto-stable-coins-bridge-with-elysium-55c5c640c90c", "_blank")} style={{ cursor: 'pointer' }}>
                <img src={BlogFiro} style={{ width: '100%', height: '13rem' }} />
                <div style={{ backgroundColor: '#08143e', padding: '2rem', marginTop: '-0.2rem', height: '8rem' }}>
                  <p style={{ fontFamily: 'Montserrat', color: '#fff', fontSize: '0.875rem', fontWeight: '500', textAlign: 'left', lineHeight: '1.5rem' }}>
                    Firo & DotOracle Partnership:Integration DTO stablecoins bridge with Elysium
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div onClick={() => window.open("https://medium.com/@dotoracle.network/okc-dotoracle-partnership-building-a-cross-chain-liquidity-bridge-for-okc-f3bb6017efb8", "_blank")} style={{ cursor: 'pointer' }}>
                <img src={BlogOkc} style={{ width: '100%', height: '13rem' }} />
                <div style={{ backgroundColor: '#08143e', padding: '2rem', marginTop: '-0.2rem', height: '8rem' }}>
                  <p style={{ fontFamily: 'Montserrat', color: '#fff', fontSize: '0.875rem', fontWeight: '500', textAlign: 'left', lineHeight: '1.5rem' }}>
                    OKC & DotOracle Partnership:Building a Cross-chain liquidity bridge for the OKX chain
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div onClick={() => window.open("https://medium.com/@dotoracle.network/aurora-dotoracle-partnership-the-first-bridge-between-aurora-and-casper-6e4b091cb4e7", "_blank")} style={{ cursor: 'pointer' }}>
                <img src={BlogAurora} style={{ width: '100%', height: '13rem' }} />
                <div style={{ backgroundColor: '#08143e', padding: '2rem', marginTop: '-0.2rem', height: '8rem' }}>
                  <p style={{ fontFamily: 'Montserrat', color: '#fff', fontSize: '0.875rem', fontWeight: '500', textAlign: 'left', lineHeight: '1.5rem' }}>
                    Aurora & DotOracle Partnership: The First bridge between Aurora and Casper
                  </p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </Blog>

    </div>
  )
}

export default HomePage
